// One failing CDN can error every image on a page, so cap these per page view to keep an outage from flooding PostHog.
const MAX_PER_EVENT = 5
let sent = {}

document.addEventListener("turbo:visit", () => {
  sent = {}
})

export const captureCapped = (event, properties) => {
  sent[event] = (sent[event] || 0) + 1
  if (sent[event] <= MAX_PER_EVENT) window.posthog?.capture(event, properties)
}
